import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {ProductsSoldReportModel} from "./products-sold-report.model";


@Component({
    selector: "products-sold-report",
    templateUrl: "./products-sold-report.component.html",
    providers: [provideReportModel(ProductsSoldReportModel)]
})
export class ProductsSoldReportComponent extends AbstractReportPage {
    constructor(public model: ProductsSoldReportModel) {
        super();
    }
}
